import { SelectOptionData } from '../../../../../components/Pi/types'
import { Currency } from './Currency'

export enum InvoiceState {
  NotCreated = 'NotCreated',
  NotComplete =  'NotComplete',
  TryComplete =  'TryComplete',
  Complete = 'Complete',
  Fail = 'Fail',
  Delegated = 'Delegated',
}

export type InvoiceInfoWithTargets = InvoiceInfo & { targets: Array<SelectOptionData> }

export type InvoiceInfo = {
  invoice_date_time: string
  invoice_date: string
  invoice_number: number,
  payer_login: string
  payer_name: string
  success: boolean,
  state: InvoiceState,
  description: string
  result: string | null
  summ: string
  count: number,
  status_url: string
  currency: Currency
  positions: Array<InvoicePosition>
}

export type InvoicePosition = {
  order?: number
  description?: string
  price?: string
  count?: number
  item_id?: number
  item_type?: number
  tariff_id?: number
  tariff_type?: number
  basePrice?: string
  type?: string
  tariff?: string
}
